export function unwrapV3ResponseData(response) {
    return response && Object.prototype.hasOwnProperty.call(response, "data") ? response.data : response;
}

export function unwrapV3ListResponse(response, label = "API v3 list") {
    const payload = unwrapV3ResponseData(response);
    if (Array.isArray(payload)) {
        return payload;
    }
    if (Array.isArray(payload?.items)) {
        return payload.items;
    }
    if (Array.isArray(payload?.data?.items)) {
        return payload.data.items;
    }
    if (Array.isArray(payload?.data)) {
        return payload.data;
    }

    throw new Error(`${label} 返回格式不符合 API v3 列表契约`);
}
